import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b86559e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deal-info" }
const _hoisted_2 = { class: "space-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" (조합원 자격) ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, "|", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "deal-detail" }
const _hoisted_7 = { class: "space-between" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" · ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 가격비교 > ")
const _hoisted_12 = { class: "space-between" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_15 = { class: "space-between" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 수량 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 약 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 주 ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 구매하기 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 입금 확인 완료. 지분 이전 대기중 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 구매 취소 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 구매신청 정보 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 다른 구매자가 입금 대기중 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_modal = _resolveComponent("ag-modal")!
  const _component_view_deposit = _resolveComponent("view-deposit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_modal, {
      "model-value": _ctx.modelValue,
      height: "auto",
      "safe-area": true,
      "swipe-to-close": true,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_header, { handle: true }),
        _createVNode(_component_modal_header, {
          title: '조합원 자격 거래',
          onClose: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'닫기', clickScreen: _ctx.clickScreen});_ctx.setOpen(false)})
        }),
        _createVNode(_component_ag_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box, {
              p: "8px 20px 0px 20px",
              dp: "flex",
              direction: "column",
              "justify-content": "space-between"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ag_text, {
                      "padding-bottom": '8px',
                      typography: 'tit20b'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.dealInfo.partnershipName) + " ", 1),
                        _createVNode(_component_ag_text_s, { css: {typography: 'main16r', color: 'gray2'} }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ag_box_s, { css: {
              dp: 'flex',
              dd: 'row',
              alignItems: 'center',
              color:'#8F929B'

            } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_icon, {
                        css: {
                mr:'4px',
                width:20,
                height:20,
                color:'#D4D9DF',
              },
                        name: "personCircleOutline"
                      }),
                      _createVNode(_component_ag_text, { typography: 'main13r' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.dealInfo.publicId) + " ", 1),
                          _hoisted_4,
                          _createTextVNode(" " + _toDisplayString(_ctx.prettyDateToOnemonth(_ctx.dealInfo.createAt)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text, { typography: 'num18bk' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfo.price)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'tit18r' }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_ag_box_s, { css: {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center',
            } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {dp: 'flex', alignItems: 'center', color: 'gray3', typography: 'main12r', bg: 'bg1', borderRadius: '4px', padding:'4px 8px'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_icon, { name: "businessOutline" }),
                          _createVNode(_component_ag_text_s, { css: {ml:'5px'} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 기업가치 " + _toDisplayString(_ctx.numberToKorean(_ctx.dealInfo.price * _ctx.dealInfo.totalStockAmount)) + "원 가격 ", 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.priceCompareRef==='show')
                            ? (_openBlock(), _createBlock(_component_ag_text_s, {
                                key: 0,
                                css: {ml:'5px', color:'#4360EC'},
                                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'주당 가격', 'clickContent':'가격비교'}); _ctx.$emit('companyClick', _ctx.dealInfo.stockItemId)})
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createVNode(_component_ag_text_s, { css: {color:'#4360EC'} }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text, { typography: 'num18bk' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfo.totalPrice)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'tit18r' }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_ag_text, {
                      color: 'gray3',
                      typography: 'main14r'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_text_s, { css: {fontSize: '18px'} }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'num18bk' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfo.qty)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, { typography: 'tit18r' }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text, {
                        color: "gray3",
                        typography: 'main14r'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" (" + _toDisplayString(_ctx.perCurrency(_ctx.dealInfo.asset)) + " 좌) ", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ag_footer, {
          p: "20px",
          mb: "safeAreaBottom"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_ag_button, {
              corner: '10px',
              width: '100%',
              disabled: !_ctx.buyBtnEnable,
              onClickCapture: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'구매하기'}); (_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.nextProcess())})
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["disabled"]), [
              [_vShow, _ctx.dealInfo.status === 'onSale']
            ]),
            _withDirectives(_createVNode(_component_ag_button, {
              corner: '10px',
              fill: "gray2",
              width: '100%'
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.dealInfo.status === 'inTransaction' && _ctx.dealInfo.partnershipSharePurchaseId && _ctx.dealInfo.payStatusByBuyer === 'PAY_IN']
            ]),
            _withDirectives(_createVNode(_component_ag_box, {
              dp: "flex",
              gap: "sp6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_button, {
                  corner: '10px',
                  outline: "primary",
                  width: '100%',
                  onClickCapture: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'구매취소'}); _ctx.cancelToBuy()})
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_button, {
                  corner: '10px',
                  fill: "mint1",
                  width: '100%',
                  onClickCapture: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'구매신청 정보'}); _ctx.printDepositInfo()})
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.dealInfo.status === 'inTransaction' && _ctx.dealInfo.partnershipSharePurchaseId && _ctx.dealInfo.payStatusByBuyer === 'ACCEPT']
            ]),
            _withDirectives(_createVNode(_component_ag_button, {
              corner: '10px',
              fill: "mint1",
              width: '100%',
              onClickCapture: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'다른 구매자가 입금 대기중'}); _ctx.openAlert('intercept')})
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.dealInfo.status === 'inTransaction' && !_ctx.dealInfo.partnershipSharePurchaseId]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_view_deposit, {
      "model-value": _ctx.viewDepositOpen,
      "open-type": 'result',
      deposit: _ctx.deposit,
      onCloseDepositModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.viewDepositOpen = false)),
      "onDelete:purchaseHistory": _ctx.resetStakeInfo
    }, null, 8, ["model-value", "deposit", "onDelete:purchaseHistory"])
  ], 64))
}